import React from 'react'
import { MemberPhoto } from '@vista-digital/occ-ui/src/lib/components/member/photo/member-photo'
import { navigationService } from '../../../services/navigation.service'
import { PagesEnum } from '../../../pages/pages'
import { MemberContextComponent } from '@vista-digital/occ-ui'

export const UserPhoto: React.FC<{ memberName?: string }> = props => {
    const { memberName } = props

    const onMemberClicked = () => {
        navigationService.goToPage(PagesEnum.MemberOverview)
    }

    // TODO: This memberContext is not with props
    return (
        <MemberContextComponent>
            <div className="member-photo" onClick={onMemberClicked}>
                <MemberPhoto />
                {/* {unreadMessages > 0 && (
                <div className="unread-messages-tag">{unreadMessages}</div>
                )} */}
            </div>
            {memberName && <div className="member-name">{memberName}</div>}
        </MemberContextComponent>
    )
}
